import Pusher from 'pusher-js'

export const subdomain = window.location.host.split('.')[0]
const token = localStorage.getItem(`${subdomain}_authorization`).replace('__q_strn|', '')

export const pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
  cluster: 'eu',
  encrypted: true,
  authEndpoint: `${process.env.VUE_APP_API_PREFIX}/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: token
    }
  }
})
